export type Environment = "production" | "development" | "local";

const LOCAL_HOSTNAMES = new Set([
    "localhost",
    "0.0.0.0",
    `127.0.0.1`
]);

const DEVELOPMENT_HOSTNAMES = new Set([
    "medendo-frontend.development.medendo.dev"
]);

export function getEnvironment(): Environment {
    const hostname = window.location.hostname.toLowerCase();

    if (LOCAL_HOSTNAMES.has(hostname)) {
        return "local";
    }

    if (DEVELOPMENT_HOSTNAMES.has(hostname)) {
        return "development";
    }
    return "production";
}
